import React from 'react';

function CCTVMonitoringSecurityDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">CCTV Monitoring Security UK</h1>
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Our CCTV monitoring security services in the UK provide around-the-clock surveillance for your property. We utilize advanced CCTV technology to monitor and protect your premises, ensuring immediate response to any suspicious activity.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>24/7 CCTV Monitoring</li>
          <li>Real-Time Surveillance</li>
          <li>Incident Detection and Reporting</li>
          <li>Remote Access to CCTV Footage</li>
          <li>Intruder Alarm Integration</li>
          <li>Detailed Incident Reports</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our team of CCTV monitoring professionals in the UK is dedicated to providing high-quality surveillance services. We employ the latest technology and adhere to strict security protocols to ensure your property is safe and secure.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our CCTV monitoring security services in the UK, please contact us at <a href="tel:07460395006" className="text-yellow-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-yellow-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default CCTVMonitoringSecurityDetails;
